// extracted by mini-css-extract-plugin
export default {"loginButtons":"LoginPage_loginButtons__mV00o"};